import React from "react";
import { UP, DOWN } from "@/lib/format";

const Item = ({ d }) => {
  const up = (d.change_pct ?? 0) >= 0;
  return (
    <div className="flex items-center gap-2 px-5 py-1 border-r border-white/10 whitespace-nowrap" data-testid={`ticker-${d.symbol}`}>
      <span className="font-semibold text-[12px] tracking-wide text-slate-200">{d.label}</span>
      <span className="font-mono text-[14px] font-bold tabular-nums text-white">
        {d.value !== null && d.value !== undefined ? Number(d.value).toLocaleString(undefined, { maximumFractionDigits: 2 }) : "—"}
      </span>
      <span className="font-mono text-[12px] font-semibold tabular-nums flex items-center gap-0.5" style={{ color: up ? "#22C55E" : "#F87171" }}>
        <span className="text-[9px]">{up ? "▲" : "▼"}</span>
        {d.change_pct === null || d.change_pct === undefined ? "—" : `${Math.abs(d.change_pct).toFixed(2)}%`}
      </span>
    </div>
  );
};

export default function TickerRibbon({ indices }) {
  const list = indices && indices.length ? indices : [];
  if (!list.length) {
    return <div className="h-8 flex items-center px-5 font-mono text-[12px] text-slate-500">Loading market indices…</div>;
  }
  const doubled = [...list, ...list];
  return (
    <div className="relative overflow-hidden h-8 flex items-center" data-testid="ticker-ribbon">
      <div className="marquee-track">
        {doubled.map((d, i) => (
          <Item key={`${d.symbol}-${i}`} d={d} />
        ))}
      </div>
    </div>
  );
}
